import { Link } from "react-router"
import { Button } from "@/components/ui/button"
import { ArrowLeft, Home, Zap } from "lucide-react"
import HomeNav from "@/components/home-nav"

export default function NotFoundPage() {
  return (
    <>
      <HomeNav />
      <div className="min-h-[90vh] bg-background flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <div className="flex items-center justify-center mb-8">
            <img src="/kanu-logo.png" alt="Kanu Energy" className="h-10" />
          </div>

          <div className="relative mb-6">
            <span className="text-[8rem] font-bold leading-none text-border select-none">
              404
            </span>
            <Zap className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-16 w-16 text-primary opacity-80" />
          </div>

          <h1 className="text-2xl font-semibold text-foreground mb-3">
            Page not found
          </h1>
          <p className="text-muted-foreground mb-8 leading-relaxed">
            This page doesn't exist or has been moved. Let's get you back on track.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button asChild>
              <Link to="/">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to home
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
